import React from 'react';
import ReactTable from 'react-table';
import _ from 'lodash';
import classnames from 'classnames';

import TablePagination from '../Pagination';

class CustomTable extends React.Component {
  render() {
    const { style, showPageSizeOptions, className, ...rest } = this.props;

    return (
      <ReactTable
        className={classnames('app-table -highlight', className)}
        defaultPageSize={10}
        minRows={0}
        style={style}
        pageSizeOptions={[10, 20, 30]}
        resizable={true}
        showPaginationBottom={false}
        showPaginationTop
        showPageSizeOptions={
          _.isUndefined(showPageSizeOptions) ? true : showPageSizeOptions
        }
        PaginationComponent={props => <TablePagination {...props} />}
        getTrProps={() => {
          return {
            className: 'pointer'
          };
        }}
        {...rest}
      />
    );
  }
}

export default CustomTable;



// WEBPACK FOOTER //
// ./components/HTMLElements/Table/Custom/index.js